



























































import {Component, Vue} from 'vue-property-decorator';
import {confirm} from 'devextreme/ui/dialog';

import request from '@/utils/request';
import {AppModule} from '@/store/modules/app';
import Breadcrumb from '@/components/Breadcrumb/index.vue';
import Hamburger from '@/components/Hamburger/index.vue';
import UnderDevelopMock from '@/components/UnderDevelop/dummy-popup.vue';
import HeaderSearch from '@/components/HeaderSearch/index.vue';
import AuthService from '@/services/auth_service';
import {Notification} from '@/services/data/notification';
import NotifyService from "@/services/notify_service";
import NotificationCounter from './NotificationCounter/notification-counter.vue';
import NotificationListPopup from './notification-list-popup.vue';
import NotificationPopup from './notification-popup.vue';
import WebSocketService from "@/services/websocket_service";
import MonitoringService, {SocketChannels} from "@/views/admin/monitoring/service";
import _ from "lodash";
import {alert} from 'devextreme/ui/dialog';

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger,
    HeaderSearch,
    UnderDevelopMock
  }
})
export default class extends Vue {
  public auth_service = AuthService;
  private notificationListPopup = {
    visible: false,
    critical: false
  };
  private shownNotification: Notification | null = null;
  private replicaProcessing: boolean = false;
  private notify = NotifyService;

  get isADAuth(): boolean {
    return AuthService.isActiveDirectoryAuth()
  }

  get isGatewayUnavailable(): boolean {
    return MonitoringService.gateway_unavailable;
  }

  async created() {
    if (this.$options.sockets) {
      this.$options.sockets.onmessage = (data: any) => {

        let res = WebSocketService.handleMsg(data, SocketChannels.service_status);
        if (!_.isNil(res)) {
          if (res.name === 'gateway') {
            if (res.status === 0) {
              // недоступен шлюз
              MonitoringService.gateway_unavailable = true;
            } else {
              MonitoringService.gateway_unavailable = false;
            }
          }
        }
      }
    }

  }

  destroyed() {
    if (this.$options.sockets) {
      delete this.$options.sockets.onmessage
    }
  }

  gatewayUnavailableAlert() {
    alert('Недоступен шлюз доступа к БД ЕСО/АРМ ПТН. Обратитесь к системному администратору', 'Ошибка доступа к шлюзу')
  }

  get sidebar() {
    return AppModule.sidebar
  }

  private under_develop = {
    visible: false
  }

  dummy_click() {
    this.under_develop.visible = true;
  }

  get device() {
    return AppModule.device.toString()
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private async sendReplica(e: any) {

    if (!this.auth_service.isAdmin()) {
      this.notify.error('Недостаточно прав для выполнения синхронизации данных в ЗС. Обратитесь к администратору', true);
      return;
    }
    e.preventDefault()
    if (this.replicaProcessing) {
      this.notify.error('Процесс синхронизации данных уже запущен. Повторный запуск возможен после завершения текущего.', true);
      return
    }
    const resp: boolean = await confirm(
      `Запустить процесс однонаправленной синхронизации данных из открытого в закрытый сегмент?`,
      'подтверждение');
    if (resp) {
      this.replicaProcessing = true
      try {
        const resp = await request({
          url: 'system_config/send_full_replica',
          method: 'get',
          timeout: 900000
        })
        if (resp) {
          this.notify.success('Процесс репликации БД успешно завершился.', true);
        }
      } catch (e) {
        this.notify.error('Процесс репликации БД завершился с ошибкой.', true);
      }
    }
    this.replicaProcessing = false
  }

  private async logout() {
    if (this.isADAuth) {
      await alert('Приложение находится в режиме работы с Active Directory', 'Завершение сеанса невозможно');
      return
    }
    confirm('Желаете завершить сеанс пользователя?', 'Завершение сеанса')
      .then(async (answer: boolean) => {
        if (!answer) {
          return
        }

        await this.auth_service.logout();
        this.$router.push(`/login`);
      })

  }

  private showNotificationsList(critical: boolean, unreadCount: number) {
    this.notificationListPopup.critical = critical;
    this.notificationListPopup.visible = true;
  }

  private hideNotificationsList() {
    this.notificationListPopup.visible = false;
  }

  private showNotification(notification: Notification) {
    this.shownNotification = notification;
  }

  private hideNotification() {
    this.shownNotification = null;
  }

}
